import useTimerHook from "@/shared/hooks/useTimerHook";
import { formatDate } from "@/shared/utils/helpers";
import dayjs, { UnitType } from "dayjs";
import { OrderV2 } from "../queries/interfacesV2";

const useOrderHelper = (order: OrderV2) => {
  const isAsap = order.order_information.hand_over_is_asap;
  const { hand_over_time } = order.order_information;
  const difference = (type: UnitType = "hour") =>
    dayjs(hand_over_time).diff(dayjs(), type);
  const data = useTimerHook(difference("minute"));
  const remainingTimeSafe = hand_over_time ? difference("hour") >= 1 : false;
  const remainingHour = formatDate(hand_over_time, "time");
  const remainingTime = hand_over_time
    ? remainingTimeSafe
      ? remainingHour
      : `${data} min`
    : undefined;

  return {
    isAsap,
    remainingTime,
    ...order.cart_content,
    ...order.order_information,
    ...order.order_user,
    difference,
    remainingTimeSafe,
    remainingHour,
  };
};

export default useOrderHelper;
